import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { InactiveResidentModalComponent } from '../inactive-resident-modal/inactive-resident-modal.component';
import { Resident } from '../../models/resident.model';

@Component({
  selector: 'app-inactive-resident-alert',
  templateUrl: './inactive-resident-alert.component.html',
  styleUrls: ['./inactive-resident-alert.component.scss'],
  imports: [MatIconModule],
})
export class InactiveResidentAlertComponent {
  @Input() resident: Resident = null;

  constructor(private dialog: MatDialog) {}

  openDialog(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialog.open(InactiveResidentModalComponent, {
      data: { resident: this.resident },
      width: '632px',
      height: 'auto',
      autoFocus: false,
    });
  }
}
